"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AuthState = _interopRequireDefault(require("../../AuthState"));

var _callEach = _interopRequireDefault(require("../../utilities/callEach"));

var _estore = require("../api/estore");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaultState = {
  authState: _AuthState["default"].UNKNOWN,
  itemsInCart: 0,
  userName: null,
  userFirstName: null
};

var ECommLoginService = /*#__PURE__*/function () {
  function ECommLoginService(config) {
    _classCallCheck(this, ECommLoginService);

    this.onChangeCallbacks = [];
    this.state = _objectSpread({}, defaultState);
    this.config = config;
  }
  /**
   * Initialize the object. Make calls to ecomm, and update the state based on responses.
   */


  _createClass(ECommLoginService, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchDetails();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
    /**
     * Fetch details. Send a request to eStore, to get cart state.
     */

  }, {
    key: "fetchDetails",
    value: function () {
      var _fetchDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userNames, cartDetails;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                userNames = this.config.nameCookies.map(_jsCookie["default"].get).filter(function (v) {
                  return typeof v !== "undefined";
                }).map(function (v) {
                  return v.trim();
                }).filter(function (v) {
                  return v.length > 0;
                });
                _context2.next = 4;
                return (0, _estore.cart)(this.config.estoreLocation);

              case 4:
                cartDetails = _context2.sent;
                userNames.push(cartDetails.userName);
                this.state.userName = userNames[0];
                this.state.userFirstName = cartDetails.firstName;
                this.state.authState = this.state.userName === "Anonymous" ? _AuthState["default"].LOGGED_OUT : _AuthState["default"].LOGGED_IN;
                this.state.itemsInCart = cartDetails.itemsInCart;
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                  authState: _AuthState["default"].LOGGED_OUT
                });
                throw _context2.t0;

              case 16:
                _context2.prev = 16;
                this.privateTriggerChange();
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12, 16, 19]]);
      }));

      function fetchDetails() {
        return _fetchDetails.apply(this, arguments);
      }

      return fetchDetails;
    }()
    /**
     * Redirect to login of tax site.
     */

  }, {
    key: "login",
    value: function login() {
      if (window) {
        window.location.assign(this.loginUrl);
      }
    }
    /**
     * Logout. Redirect to logout of Hybris.
     */

  }, {
    key: "logout",
    value: function logout() {
      if (window) {
        window.location.assign(this.logoutUrl);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      (0, _callEach["default"])(this.onChangeCallbacks, this);
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.config.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.state.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.config.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.state.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.config.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.config.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.state.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.state.userFirstName;
    }
  }]);

  return ECommLoginService;
}();

exports["default"] = ECommLoginService;